import type { DeckDraft } from '../types/deck';

/**
 * Thrown when a client draft write observes that the deck was published
 * after this save started. Callers must republish through the server route
 * instead of writing `status: 'draft'` over the published document.
 */
export class DeckPublishedDuringSave extends Error {
  constructor() {
    super('Deck was published while this save was in flight');
    this.name = 'DeckPublishedDuringSave';
  }
}

/**
 * Autosave and Save keep the builder's in-memory status. Publish updates
 * Firestore first and the builder second, so a save already in flight still
 * carries `draft`. Writing that payload is allowed by security rules and
 * unpublishes the deck, which removes it from the team deck list.
 */
export function draftForClientPersist(
  serverStatus: DeckDraft['status'] | undefined,
  draft: DeckDraft,
): DeckDraft {
  if (serverStatus === 'published') {
    return { ...draft, status: 'published' };
  }
  return draft;
}
